import AvatarCircle from 'components/Common/AvatarCircle/AvatarCircle'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import useRebrandLightSurfaceButtonVariant from 'hooks/useRebrandLightSurfaceButtonVariant'
import Divider from 'LuxKit/Divider'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

export type WeddingGiftRegistryWelcomeModalResult = 'keep_browsing' | 'dismiss' | 'back_to_setup'

function WeddingGiftRegistryWelcomeModal() {
  const intl = useIntl()
  const { resolve } = useModalElementContext<WeddingGiftRegistryWelcomeModalResult>()
  const lightSurfaceButtonVariant = useRebrandLightSurfaceButtonVariant()

  const onConfirm = useCallback(() => {
    resolve('keep_browsing')
  }, [resolve])

  const onBackToSetup = useCallback(() => {
    resolve('back_to_setup')
  }, [resolve])

  return (
    <Modal
      size="S"
      title={intl.formatMessage({ defaultMessage: 'Create your dream gift registry', id: 'qxhdwuNP0Nx-Q97s72ba' })}
      primaryActionText={intl.formatMessage({ defaultMessage: 'Start browsing', id: 'HbvO6t4cUj2EjLfLosG-' })}
      onPrimaryActionClick={onConfirm}
      secondaryActionText={intl.formatMessage({ defaultMessage: 'Go back to setup', id: '_J4I7Ej-esOnjlGJT5Zb' })}
      onSecondaryActionClick={onBackToSetup}
    >
      <Group direction="vertical">
        <Sheet padding="12 20">
          <Group direction="horizontal" gap={12}>
            <AvatarCircle size="small" variant={lightSurfaceButtonVariant} firstName="1" lastName=" " />
            <Group direction="vertical">
              <BodyText variant="large" weight="bold">
                {intl.formatMessage({
                  id: '8CWXjve8zd1DbR18GWaJ',
                  defaultMessage: 'Browse and add gifts to your gift registry cart',
                })}
              </BodyText>
              <BodyText variant="medium">
                {intl.formatMessage({
                  id: '5m_ef_J3b1192X3rr2ZH',
                  defaultMessage: 'Add hotels, experiences, cruises, tours or flights for guests to contribute toward.',
                })}
              </BodyText>
            </Group>
          </Group>
        </Sheet>
        <Divider kind="secondary" direction="horizontal" />
        <Sheet padding="12 20">
          <Group direction="horizontal" gap={12}>
            <AvatarCircle size="small" variant={lightSurfaceButtonVariant} firstName="2" lastName=" " />
            <Group direction="vertical">
              <BodyText variant="large" weight="bold">
                {intl.formatMessage({
                  id: 'oHj8BhRfbOdTe0Ex4wf5',
                  defaultMessage: 'Sync your selections',
                })}
              </BodyText>
              <BodyText variant="medium">
                {intl.formatMessage({
                  id: '7Hsw5_eDXH8gVoKdUSZl',
                  defaultMessage: "When you're ready, click ‘Sync to registry’ in your cart to return to your setup page. We'll sync your items.",
                })}
              </BodyText>
            </Group>
          </Group>
        </Sheet>
      </Group>
    </Modal>
  )
}

export default WeddingGiftRegistryWelcomeModal
